import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { GridOptions, RowNode } from 'ag-grid-community';
import { User } from '../models/user.model';
import { Clinic } from '../models/clinic.model';
import { ReportListRequest } from '../models/reportlistrequest.model';
import { Constants } from '../util/constants';
import { AlertService } from '../util/alert/alert.service';
import { LocalStorage } from '../util/localstorage.service';
import { MachineDataService } from '../admin/machine/machine-data.service';
import { ClinicDataService } from '../admin/clinic/clinic-data.service';
import { TBBO2TherapyReportDataService } from './tbbo2-therapy-report-data.service';
import { BsModalService,BsModalRef}   from 'ngx-bootstrap/modal';
import { UserDataService } from '../admin/user/user-data.service';
import { DatePipe } from '@angular/common';
import { TBBO2TherapyReportCustomCellComponent } from './tbbo2-therapy-report-custom-cell/tbbo2-therapy-report-custom-cell.component';


@Component({
  selector: 'app-tbbo2-therapy-report',
  templateUrl: './tbbo2-therapy-report.component.html',
  styleUrls: ['./tbbo2-therapy-report.component.scss']
})
export class TBBO2TherapyReportComponent implements OnInit {

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public loggedUser: User
  private gridApi: any;
  private gridColumnApi: any;
  public columnDefs: any;
  public rowData: any;
  public defaultColDef
  public reportlistrequest: ReportListRequest
  public gridOptions : GridOptions
  public clinicid
  public clinic
  public clinics
  public clinicname
  public clinicfilter

  public location
  public locationfilter
  public locationid
  public locationname
  public locationchange: boolean = true

  public equipment
  public equipmentid
  public equipmentname

  public userid
  public user
  public users
  public username
  public userfilter

  public therapymodeid
  public therapymode
  public therapymodename
  public therapymodefilter

  public patientid
  public patientname

  public clinicsforfilter: Array<any> =[]
  public locationsforfilter: Array<any> =[]
  public equipmentsforfilter: Array<any> =[]
  public usersforfilter: Array<any> =[]
  public therapymodesforfilter: Array<any> =[]
  public selectedClinicFilter: Array<any> =[]
  public selectedLocationFilter: Array<any> =[]
  public selectedUserFilter: Array<any> =[]
  public isSuperUser
  public updateMode
  public fromdate
  public todate

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService, private userService: UserDataService,
    private machineService: MachineDataService,private clinicService: ClinicDataService, private tbbo2TherapyReportsService: TBBO2TherapyReportDataService, private bsModalService :BsModalService) {

    var self = this;
    this.gridOptions = {
      rowData: this.rowData,
      columnDefs: this.columnDefs,
      enableColResize: true,
      enableSorting: true,
      rowSelection: "single",
      rowDeselection: true,
      rowHeight: 35,
      animateRows: true,
      rowBuffer: 20,
      context: {
        componentParent: this
      },
      paginationPageSize: 10
    };

    this.defaultColDef = {
      //autoHeight: true,
      resizable: true,
      filter: true,
    };
    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser || this.loggedUser.UserRoleID == Constants.UserRoleID.User){
      this.isSuperUser = false
    } else{
      this.isSuperUser = true
    }
    this.columnDefs = [
      {
        headerName: 'Patient Name',
        field: 'patientname',
        width: 60,
        // hide: this.isSuperUser
      },
      {
        headerName: 'Date Of Birth',
        field: 'dob',
        cellStyle: {textAlign: "left"},
        width: 60
      },
      {
        headerName: 'Gender',
        field: 'ismale',
        width: 60
      },
      {
        headerName: 'User',
        field: 'username',
        width: 60
      },
      {
        headerName: 'Therapy Mode',
        field: 'therapymode',
        width: 60
      } ,
      {
        headerName: 'Session Date',
        field: 'sessiondatetime',
        cellStyle: {textAlign: "left"},
        width: 60
      },
      {
        headerName: '',
        field: 'view',
        cellStyle: {textAlign: "center"},
        width: 40,
        cellRendererFramework: TBBO2TherapyReportCustomCellComponent,
      },
      // {
      //   headerName: '',
      //   field: 'view',
      //   cellStyle: {textAlign: "center"},
      //   width: 40,
      //   cellRenderer: function(params) {
      //     var input1 = document.createElement('button');
      //     input1.type="button";
      //     input1.className = "btn btn-primary btn-sm";
      //     input1.innerHTML = '<i class="far fa-file"></i>';
      //     input1.textContent = "View";
      //     input1.style.width = "60px";
      //     input1.style.paddingBottom = "5px";
      //     document.body.appendChild(input1);
      //     input1.addEventListener('click', function (event) {
      //         self.viewBtnClickEvent(params.data);
			// 		});
			// 		return input1
			// 	}
      // }
    ];
   }

  ngOnInit(): void {
    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser || this.loggedUser.UserRoleID == Constants.UserRoleID.User){
      this.isSuperUser = false
    } else{
      this.isSuperUser = true
    }
    this.clinicid = this.loggedUser.ClinicID
    this.fromdate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      new Date().getDate())
    this.todate = new Date()

    this.iSForm = this.formBuilder.group({
      patientname: new FormControl(null),
      name: new FormControl(null),
      clinic: new FormControl(null),
      clinicname: new FormControl(null),
      location: new FormControl(null),
      locationname: new FormControl(null),
      equipment: new FormControl(null),
      equipmentname: new FormControl(null),
      user: new FormControl(null),
      username: new FormControl(null),
      therapymode: new FormControl(null),
      therapymodename: new FormControl(null),
      clinicfilter: new FormControl(null),
      locationfilter: new FormControl(null),
      equipmentfilter: new FormControl(null),
      userfilter: new FormControl(null),
      therapymodefilter: new FormControl(null),
      fromdate: new FormControl(null),
      todate: new FormControl(null)
    } );

    this.loadInitialData()
    this.loadUserData()
    this.loadReportData()
  }

  loadInitialData()
	{
    this.alertService.clear()
    this.machineService.getEquipments(this.loggedUser).subscribe(data => this.getEquipmentData(data))
    this.clinicService.getClinics(this.loggedUser).subscribe(data => this.getClinicData(data))
    this.loadTherapyModeData()
  }

  loadUserData()
	{
    this.alertService.clear()
    this.userService.getUsers(this.clinicid,this.loggedUser).subscribe(data => this.getUserData(data))
  }

  loadReportData()
	{
    this.alertService.clear()
    if (this.validateReportListRequest()){
     this.reportlistrequest = new ReportListRequest()
     this.reportlistrequest.ClinicID = this.clinicid
     this.reportlistrequest.PatientID = null
     this.reportlistrequest.FromDate = this.fromdate.toLocaleDateString()
     this.reportlistrequest.ToDate = this.todate.toLocaleDateString()
     this.tbbo2TherapyReportsService.getSessionsForReportList(this.reportlistrequest,this.loggedUser).subscribe(data => this.getGetSessionsForReportListData(data))
    }
  }

  validateReportListRequest(){
    if ((this.iSForm.controls.fromdate.value != "") && (this.iSForm.controls.fromdate.value != null) && (this.iSForm.controls.fromdate.value == "Invalid Date"))
    {
      this.alertService.clear()
      this.alertService.error('Invalid From Date')
      return false
    }
    if ((this.iSForm.controls.todate.value != "") && (this.iSForm.controls.todate.value != null) && (this.iSForm.controls.todate.value == "Invalid Date"))
    {
      this.alertService.clear()
      this.alertService.error('Invalid To Date')
      return false
    }
    if (this.fromdate > this.todate)
    {
      this.alertService.clear()
      this.alertService.error('Invalid Date Range')
      return false
    }
    return true
  }


  public getGetSessionsForReportListData(data: any) {
    let reports: Array<any>=[]
    data.forEach((element: any) => {
      let DateOfBirth
      let SessionDateTime
      let IsMale
      var datePipe = new DatePipe('en-US');
      if(datePipe.transform(element.DateOfBirth, 'MM/dd/yyyy') != Constants.Date.MinValue){
        DateOfBirth = datePipe.transform(element.DateOfBirth, 'MM/dd/yyyy');
      } else{
        DateOfBirth = "";
      }
      if(datePipe.transform(element.SessionDateTime, 'MM/dd/yyyy') != Constants.Date.MinValue){
        SessionDateTime = datePipe.transform(element.SessionDateTime, 'MM/dd/yyyy');
      } else{
        SessionDateTime = "";
      }
      if(element.IsMale == true){
        IsMale = "Male"
      } else{
        IsMale = "Female"
      }

      reports.push({sessionid: element.SessionID, clinicid: element.ClinicID, clinicname: element.ClinicName,
        locationid: element.LocationID, locationname: element.LocationName, userid: element.UserID,
        username: element.UserName, equipmentid: element.EquipmentID, equipmentname: element.EquipmentName,
        patientid: element.PatientID, patientname: this.isSuperUser ? (Constants.PatientRefOffset + parseInt(element.PatientReferenceNo, 10)) + '' : element.PatientName + " ["+(Constants.PatientRefOffset + parseInt(element.PatientReferenceNo, 10)) + '' + "]",
        therapymode: element.TherapyMode ,ismale: IsMale, dob: DateOfBirth, sessiondatetime: SessionDateTime})
    });
    this.rowData = reports;
    return this.rowData;
  }

  public getClinicData(data: any) {
    this.clinics = data
    this.clinicsforfilter = []

    this.locationsforfilter = []
    this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
    this.selectedLocationFilter = this.locationsforfilter[0]

    data.forEach((element: any, index: any) => {
		this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
      if(this.clinicid != null && this.clinicid != undefined && this.clinicid == element.ClinicID){
        if(!this.isSuperUser){
          this.clinicname = element.ClinicName
          this.clinicfilter = element.ClinicName
        }
        element.Location.forEach((e: any) => {
          if(this.locationid != null && this.locationid != undefined && this.locationid == e.LocationID){
            this.locationname = e.LocationName
          }
          this.locationsforfilter.push({LocationID: e.LocationID, LocationName: e.LocationName});
        });
        this.selectedClinicFilter = this.clinicsforfilter[index]
        this.sortLocationRemainingFilters()
        if(this.locationchange != false){
          this.loadUserData()
        }
        this.loadReportData()
      }
    });
    return this.clinics;
  }

  public getEquipmentData(data: any) {
    this.equipmentsforfilter = []
    this.equipmentsforfilter.push({EquipmentID: "0", EquipmentName: Constants.DefaultValues.DropDownValue});
    this.equipmentname = Constants.DefaultValues.DropDownValue
    this.equipment = this.equipmentsforfilter[0]
    data.forEach((element: any) => {
      this.equipmentsforfilter.push({EquipmentID: element.EquipmentID, EquipmentName: element.EquipmentName});
    });
    return this.equipmentsforfilter;
  }

  public loadTherapyModeData() {
    this.therapymodesforfilter = []
    this.therapymodesforfilter.push({TherapyModeID: "0", TherapyModeName: Constants.DefaultValues.DropDownValue},
    {TherapyModeID: "1", TherapyModeName: "Control"},{TherapyModeID: "2", TherapyModeName: "Steady State"},
    {TherapyModeID: "3", TherapyModeName: "SpO2 Burst"});
    this.therapymodename = Constants.DefaultValues.DropDownValue
    this.therapymode = this.therapymodesforfilter[0]
    return this.therapymodesforfilter;
  }

  public getUserData(data: any) {
    this.users = data
    this.usersforfilter = []
    this.selectedUserFilter = []
    this.usersforfilter.push({UserID: "0", UserName: Constants.DefaultValues.DropDownValue, FirstName: null, MiddleName: null, LastName: null});
    this.selectedUserFilter = this.usersforfilter[0]

    data.forEach((element: any) => {
      let username = element.FirstName + " " + element.LastName
      this.usersforfilter.push({UserID: element.UserID, UserName: username, FirstName: element.FirstName, MiddleName: element.MiddleName, LastName: element.LastName});
    });
    return this.usersforfilter;
  }

  // exitBtnClickEvent(){
  //   this.router.navigateByUrl('landing');
  // }

  searchBtnClickEvent(){
    this.alertService.clear()
    this.externalFilterChanged()
  }

  externalFilterChanged() {
    if(this.gridApi != undefined){
      this.gridApi.onFilterChanged();
    }
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass = (node: RowNode): boolean => {
    var PatientName = node.data.patientname.toLowerCase()
    var UserName = node.data.username.toLowerCase()
    var LocationName = node.data.locationname.toLowerCase()
    var EquipmentName = node.data.equipmentname.toLowerCase()
    var TherapyMode = node.data.therapymode.toLowerCase()

    var isUserFilterNotPresent = (this.userfilter == null || this.userfilter == undefined || this.userfilter == "" || this.userfilter == Constants.DefaultValues.DropDownValue)
    var isLocationfilterFilterNotPresent = (this.locationfilter == null || this.locationfilter == undefined || this.locationfilter == "" || this.locationfilter == Constants.DefaultValues.DropDownValue)
    var isEquipmentFilterNotPresent = (this.equipment.EquipmentName == null || this.equipment.EquipmentName == undefined || this.equipment.EquipmentName == "" || this.equipment.EquipmentName == Constants.DefaultValues.DropDownValue)
    var isTherapyModeFilterNotPresent = (this.therapymode.TherapyModeName == null || this.therapymode.TherapyModeName == undefined || this.therapymode.TherapyModeName == "" || this.therapymode.TherapyModeName == Constants.DefaultValues.DropDownValue)
    var isPatientFilterNotPresent = (this.patientname == null || this.patientname == undefined || this.patientname == "")

    //To check whether the filter is tru
    var isLocationFilterTrue : boolean = false
    if (!isLocationfilterFilterNotPresent)
      isLocationFilterTrue = (LocationName == this.locationfilter.toLowerCase())

    var isUserFilterTrue : boolean = false
    if (!isUserFilterNotPresent){
      isUserFilterTrue=(UserName.includes(this.userfilter.toLowerCase()))
      this.gridOptions.columnApi.setColumnVisible('username', false)
    } else{
      this.gridOptions.columnApi.setColumnVisible('username', true)
    }

    var isEquipmentFilterTrue : boolean = false
    if (!isEquipmentFilterNotPresent)
    isEquipmentFilterTrue = (EquipmentName == this.equipment.EquipmentName.toLowerCase())

    var isTherapyModeFilterTrue : boolean = false
    if (!isTherapyModeFilterNotPresent){
      isTherapyModeFilterTrue = (TherapyMode == this.therapymode.TherapyModeName.toLowerCase())
      this.gridOptions.columnApi.setColumnVisible('therapymode', false)
    } else{
      this.gridOptions.columnApi.setColumnVisible('therapymode', true)
    }

    var isPatientFilterTrue : boolean = false
    if (!isPatientFilterNotPresent){
      isPatientFilterTrue = (PatientName.includes(this.patientname.toLowerCase()))
      //this.gridOptions.columnApi.setColumnVisible('patientname', false)
    } else{
      //this.gridOptions.columnApi.setColumnVisible('patientname', true)
    }
    this.gridOptions.api.sizeColumnsToFit();

    // Return true for node which fulfil filter criteria
    if ((isLocationfilterFilterNotPresent || (!isLocationfilterFilterNotPresent && isLocationFilterTrue)) &&
        (isUserFilterNotPresent || (!isUserFilterNotPresent && isUserFilterTrue)) &&
        (isEquipmentFilterNotPresent || (!isEquipmentFilterNotPresent && isEquipmentFilterTrue)) &&
        (isTherapyModeFilterNotPresent || (!isTherapyModeFilterNotPresent && isTherapyModeFilterTrue)) &&
        (isPatientFilterNotPresent || (!isPatientFilterNotPresent && isPatientFilterTrue)))
    {
      return true
    }
  }

  gridSizeChanged(params: any) {
		params.api.sizeColumnsToFit();
  }

  onGridReady(params: any) {
    this.rowData = []
		this.gridApi  = params.api;
    this.gridColumnApi = params.columnApi;
  }

  sortLocationRemainingFilters(){
    if(this.selectedClinicFilter["Location"] != null && this.selectedClinicFilter["Location"] != undefined){
      this.locationsforfilter = []
      this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
      if(this.clinicfilter == Constants.DefaultValues.DropDownValue){
        this.selectedLocationFilter = this.locationsforfilter[0]
      }
      this.selectedClinicFilter["Location"].forEach((element: any) => {
        if((element.LocationName == Constants.DefaultValues.LocationName) && (element.LocationName != this.selectedLocationFilter["LocationName"])){
          this.locationsforfilter.push({LocationID: element.LocationID, LocationName: element.LocationName});
        }
      });
      this.selectedClinicFilter["Location"].forEach((element: any) => {
        if((element.LocationName != Constants.DefaultValues.LocationName) && (element.LocationName != this.selectedLocationFilter["LocationName"])){
          this.locationsforfilter.push({LocationID: element.LocationID, LocationName: element.LocationName});
        }
      });
    }
  }

  sortUserRemainingFilters(){
    this.usersforfilter = []
    this.usersforfilter.push({UserID: "0", UserName: Constants.DefaultValues.DropDownValue, FirstName: null, MiddleName: null, LastName: null});
    if((this.selectedUserFilter["UserName"] != Constants.DefaultValues.DropDownValue) && this.selectedUserFilter != null && this.selectedUserFilter != undefined && this.selectedUserFilter.length != 0){
      this.users.forEach((element: any) => {
        if(element.UserID != this.selectedUserFilter["UserID"]){
          let username = element.FirstName + " " + element.LastName
          this.usersforfilter.push({UserID: element.UserID, UserName: username, FirstName: element.FirstName, MiddleName: element.MiddleName, LastName: element.LastName});
        }
      });
    } else{
      this.users.forEach((element: any) => {
        let username = element.FirstName + " " + element.LastName
        this.usersforfilter.push({UserID: element.UserID, UserName: username, FirstName: element.FirstName, MiddleName: element.MiddleName, LastName: element.LastName});
      });
      this.selectedUserFilter = this.usersforfilter[0]
    }
  }

  clinicFilter(){
    if(this.selectedClinicFilter != null && this.selectedClinicFilter != undefined){
      this.clinicid = this.selectedClinicFilter["ClinicID"]
      this.resetFilters()
    } else{
      this.clinicid = this.loggedUser.ClinicID
      this.resetFilters()
    }
	  this.searchBtnClickEvent()
  }

  locationFilter(): void {
    if(this.selectedLocationFilter != null && this.selectedLocationFilter != undefined && this.selectedLocationFilter.length != 0){
      this.locationfilter = this.selectedLocationFilter["LocationName"]
      this.sortLocationRemainingFilters()
    } else{
      this.locationfilter = Constants.DefaultValues.DropDownValue
      this.locationchange = false
      this.getClinicData(this.clinics)
    }
    this.searchBtnClickEvent()
  }

  userFilter(){
    if(this.selectedUserFilter != null && this.selectedUserFilter != undefined && this.selectedUserFilter.length != 0){
      this.userfilter = this.selectedUserFilter["UserName"]
      this.sortUserRemainingFilters()
    } else{
      this.userfilter = Constants.DefaultValues.DropDownValue
      this.getUserData(this.users)
    }
    this.searchBtnClickEvent()
  }

  onStartDateChange(event){
    this.fromdate = new Date(event)
    this.loadReportData()
  }

  onEndDateChange(event){
    this.todate = new Date(event)
    this.loadReportData()
  }

  viewBtnClickEvent(event: any){
    this.alertService.clear()
    this.alertService.info('Opening report. Please wait.')

    setTimeout(() => {
      this.tbbo2TherapyReportsService.getreportforpreview(event.sessionid, this.loggedUser).subscribe(data => {

        var file = new Blob([data], {type: 'application/pdf'});
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        this.alertService.clear()
      },
        error => {
          this.alertService.clear()
          this.alertService.error('Error occured while opening pdf report')
      });
    }, 50);
  }

  cancelBtnClickEvent(){
    this.clinicid = this.loggedUser.ClinicID
    this.resetFilters()
    //this.externalFilterChanged()
  }

  resetFilters(){
    this.locationchange = true
    this.getClinicData(this.clinics)
    this.locationfilter = Constants.DefaultValues.DropDownValue
    this.userfilter = Constants.DefaultValues.DropDownValue
    this.patientname = ""
    this.therapymode = this.therapymodesforfilter[0]
    this.equipment = this.equipmentsforfilter[0]
    this.fromdate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      new Date().getDate())
    this.todate = new Date()
  }

}

